const REs = {
  invalid: /^(12345678|abcdefgh|password)$/i,
  digits: /\d/,
  lower: /[a-z]/,
  upper: /[A-Z]/,
  nonWords: /\W/
}

export enum PasswordComplexity { Weak, Good, Strong }

/** For a field that takes an existing password: it must accept every password that can sign in. */
export const SIGN_IN_PASSWORD_RULES = 'required|max:50'

export const calculatePasswordComplexity = (password: string): number => {
  let score = 0
  const invalidPatterns = REs.invalid.test(password)
  if (invalidPatterns || password.length < 8) {
    return 0
  }

  const letterCounts: Record<string, number> = {}
  for (let i = 0; i < password.length; i++) {
    const letter = password[i]
    if (letter === undefined) continue
    letterCounts[letter] = (letterCounts[letter] || 0) + 1
    score += 5.0 / letterCounts[letter]
  }
  const variations = {
    digits: REs.digits.test(password),
    lower: REs.lower.test(password),
    upper: REs.upper.test(password),
    nonWords: REs.nonWords.test(password)
  }

  const variationCount = Object.values(variations).reduce((sum, val) => sum + (val ? 1 : 0), 0)
  score += (variationCount - 1) * 10
  return score
}

export const calculatePasswordStrength = (password: string): PasswordComplexity => {
  const score = calculatePasswordComplexity(password)
  if (score >= 70) {
    return PasswordComplexity.Strong
  } else if (score >= 50) {
    return PasswordComplexity.Good
  }
  return PasswordComplexity.Weak
}
